module.exports = __webpack_public_path__ + "static/img/shareholder.3256af2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/company/shareholder.jpg
// module id = SoOP
// module chunks = 2